import { render, staticRenderFns } from "./CollectorList.vue?vue&type=template&id=2c31eb39&scoped=true&"
import script from "./CollectorList.vue?vue&type=script&lang=js&"
export * from "./CollectorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c31eb39",
  null
  
)

export default component.exports